import React from "react";

export function Apibox({
  name,
  datatype,
  req_type,
  children,
}: {
  name: string;
  datatype: string;
  req_type: string;
  children: any;
}) {
  // `name` and `datatype` are used internally but not rendered in the UI
  return (
    <div className="border-[1px] border-t-slate-700 p-3">
      <div className="flex gap-3">
        {/* Only render the required type */}
        {/* <p className="text-red-600">{req_type}</p> */}
      </div>
      {/* Render the children content */}
      <div>{children}</div>
    </div>
  );
}
